__turbopack_context__.v({
  "chartsWrapper": "charts-module-scss-module__MlJ6Ma__chartsWrapper",
  "isShowCharts": "charts-module-scss-module__MlJ6Ma__isShowCharts",
});
